var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.list.length)?_c('div',{staticClass:"tgs-box"},[_c('div',{staticClass:"tgs-wapper",style:({
      animationDuration: (_vm.list.length >= _vm.min ? _vm.list.length * 8 : 0) + 's',
    })},[_vm._t("default")],2),(_vm.list.length >= _vm.min)?_c('div',{staticClass:"tgs-wapper",style:({
      animationDuration: (_vm.list.length >= _vm.min ? _vm.list.length * 8 : 0) + 's',
    })},[_vm._t("default")],2):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }